const decorData = [
  {
    title: "Baby shower Deco 1",
    image: "https://www.partyone.in/suploads/2025/Mar/07/39371/1741338944image-8-1.webp",
    description: "Parent to be baby shower Balloon Decoration",
    price: 7699,
    rating: 4.5
  },
  {
    title: "Baby shower Deco 2",
    image: "https://www.partyone.in/suploads/2024/Jun/25/38846/1719301766IMG_E6888.webp",
    description: "Baby elephant theame decoration",
    price: 8999,
    rating: 4
  },
  {
    title: "Baby shower Deco 3",
    image: "https://www.partyone.in/suploads/2025/Mar/07/39372/1741339371image-7-1.webp",
    description: "Dreamy pastel theame baby decoration",
    price: 5300,
    rating: 4.2
  },
  {
    title: "Baby shower Deco 4",
    image: "https://www.partyone.in/suploads/2025/Mar/07/39367/1741330554images1000x563.webp",
    description: "Foot print baby theame decoration",
    price: 6999,
    rating: 4.2
  },
  {
    title: "Baby theame Deco 5",
    image: "https://www.partyone.in/suploads/2025/Mar/07/39370/1741338522image-9-1-1.webp",
    description: "Mother to be baby decoration",
    price: 14999,
    rating: 4.6
  },
  {
    title: "Baby showe Deco 6",
    image: "https://www.partyone.in/suploads/2024/Jul/02/38902/1719914462IMG_E8070.webp",
    description: "Neon light baby shower decoration",
    price: 6699,
    rating: 4.6
  },
  {
    title: "welcome baby Deco",
    image: "https://www.partyone.in/suploads/2025/Mar/14/39406/1741933590image-80.webp",
    description: "Beautiful Flamingo Birthday ring Decoration",
    price: 1999,
    rating: 5
  },
  {
    title: "Welcome baby Deco",
    image: "https://www.partyone.in/suploads/2024/Jul/23/38860/1721709080IMG_E5722.webp",
    description: "Cute baby girl welcome",
    price: 2600,
    rating: 4.9
  },
  {
    title: "Welcome baby Deco",
    image: "https://www.partyone.in/suploads/2025/Mar/17/39418/1742192223image-79.webp",
    description: "Welcome baby butterfly Theame Deco",
    price: 5900,
    rating: 4.7
  },
  {
    title: "Anniversary Deco",
    image: "https://www.partyone.in/suploads/2024/Mar/26/38761/171145021625th_Anniversary.webp",
    description: "25th Aniversary Gold and Pastel baloon Decoration",
    price: 12499,
    rating: 4.1
  },
  {
    title: "Aniversary Deco",
    image: "https://www.partyone.in/suploads/2025/Feb/22/39336/1740208361image-46.webp",
    description: "Elagent floral Aniversary deco",
    price: 7399,
    rating: 4
  },
  {
    title: "Aniversary Deco",
    image: "https://www.partyone.in/suploads/2023/Dec/11/38300/1702269376Product_Aniversary.webp",
    description: "Golden theame Aniversary Deco",
    price: 9999,
    rating: 4.8
  },
  {
    title: "Bride Tobe Deco",
    image: "https://www.partyone.in/suploads/2025/Feb/06/39307/1738845610image-129_Nero-AI_Photo-1.webp",
    description: "Bride to be cabana Terrace Decoration",
    price: 17999,
    rating: 4.6
  },
  {
    title: "Bride Tobe Deco",
    image: "https://www.partyone.in/suploads/2023/Nov/23/38318/1700722864Product_lets%20party.webp",
    description: "Lets party bachelorette Decoration",
    price: 9999,
    rating: 5
  },
  {
    title: "Bride tobe Deco",
    image: "https://www.partyone.in/suploads/2024/Jul/04/38946/1720087023IMG_4207-Oh-baby.webp",
    description: "Shimmery silver bride tobe",
    price: 3900,
    rating: 4.3
  },
  {
    title: "Bride Tobe Deco",
    image: "https://www.partyone.in/suploads/2024/Jun/29/38878/1719667528IMG_5405.webp",
    description: "Black groom tobe decoration with frills",
    price: 2399,
    rating: 5
  },
  {
    title: "Valeintines deco",
    image: "https://www.partyone.in/suploads/2024/Jun/29/38877/1719666385IMG_4988.webp",
    description: "i love u red foil boloon",
    price: 1700,
    rating: 4.5
  }
  // ...add more as needed
];

export default decorData;
